var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TopArrowC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 38h-5.5L40 25.5V58h-4V25.5L23.5 38H18l20-20 20 20z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Top_arrow_C.5a179b72.svg";
export { SvgJ1TopArrowC as ReactComponent };